import { render, staticRenderFns } from "./UserEkspedisiUpload.vue?vue&type=template&id=6a168990&scoped=true"
import script from "./UserEkspedisiUpload.vue?vue&type=script&lang=js"
export * from "./UserEkspedisiUpload.vue?vue&type=script&lang=js"
import style1 from "./UserEkspedisiUpload.vue?vue&type=style&index=1&id=6a168990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a168990",
  null
  
)

export default component.exports